// extracted by mini-css-extract-plugin
export default {"text":"rebate_text__4uIKA","button":"rebate_button__Nupz5"};